//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      parentStyles: {},
      color: null
    };
  },
  methods: {
    $ready: function $ready() {
      var vm = this;
      this.$type.ifArray(this.spec.styleClasses, function (val) {
        ["success", "info", "warning", "error"].forEach(function (color) {
          if (val.remove(color)) {
            vm.color = color;
          } // if (val.includes(color)) {
          //   vm.color = color
          // }

        });
      });
    }
  }
};